define('modules/page_listing/views/search_list',['require','exports','module','base/collectionview','../models/tag','../collections/tags','./search_list_item','lib/util'],function(require,exports,module){
  "use strict";
  
  var CollectionView = require("base/collectionview"),
      Tag = require("../models/tag"),
      TagCollection = require("../collections/tags"),
      ItemView = require("./search_list_item"),
      util = require("lib/util");

  var Controller = {
    selectedIndex: -1,
    resetIndex: function() {
      this.selectedIndex = -1;
    },
    hasTagSelected: function(){
      return this.selectedIndex !== -1;
    },
    selectTag: function(delta) {
      this.clearFocus();
      this.selectedIndex += delta;
      if (this.selectedIndex > this.collection.length - 1) {
        this.selectedIndex = 0;
      } else if (this.selectedIndex < 0) {
        this.selectedIndex = this.collection.length - 1;
      }
      var tag = this.getSelectedTag();
      tag.trigger("tag:selected");
    },
    selectNextTag: function() {
      this.selectTag(1);
    },
    selectPrevTag: function() {
      this.selectTag(-1);
    },
    unselectAll: function() {
      this.resetIndex();
      this.clearFocus();
    },
    getSelectedTag: function() {
      return this.collection.at(this.selectedIndex);
    },
    clearFocus: function() {
      this.$("li").removeClass("is-focused");
    }
  };

  module.exports = CollectionView.extend({
    tagName: "ul",
    className: "ed-search-list",
    itemView: ItemView,
    initialize: function(options){
      this.collection = this.collection || new TagCollection();
      this.listenTo(this.childVent, "tag:select", this.onClick); 
    },
    onClick: function(view, nop, tag) {
      var i = this.collection.indexOf(tag);
      this.selectedIndex = 0;
      this.selectTag(i);
      this.trigger("tag:select");
    }
  });

  util.mixin(module.exports, Controller);
});

